export default __webpack_public_path__ + "static/media/safekey.108b4272.png";